import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search\">\n<path d=\"M475 475L325.003 325M375 200C375 296.65 296.65 375 200 375C103.35 375 25 296.65 25 200C25 103.35 103.35 25 200 25C296.65 25 375 103.35 375 200Z\" stroke=\"currentColor\" stroke-width=\"25\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol